import {IPlayerService} from "./IPlayerService";
import {Observable} from 'rxjs';


export interface IPlayer {
  playerService: IPlayerService;
  parentPlayer: IPlayer;
  providerData: any;
  fieldName: string;
  playerObject: any;
  data: any;
  actualWidth: number;
  actualHeight: number;
  scaleX: number;
  scaleY: number;
  usePlayerLayoutX: boolean;
  usePlayerLayoutY: boolean;
  originalSize: any;
  load(playerObject: any): Observable<any>;
  onClick(event);

  getAnimInfo();
};
